import { ThemeSize } from "@/types/styles/ThemeSize";
import { createContext } from "react";

export const ChosenThemeSizeContext = createContext<ThemeSize | undefined>(undefined);

export default ChosenThemeSizeContext;